var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { freeProductInfo, probioticInfo, treatInfo } from './extras';
import { recipeInfo } from './meals';
export * from './extras';
export * from './meals';
export var allProductInfos = __assign(__assign(__assign(__assign({}, recipeInfo), treatInfo), probioticInfo), freeProductInfo);
export function getProductInfoBySlug(slug) {
    var productKey = Object.keys(allProductInfos).find(function (key) { return allProductInfos[key].slug === slug; });
    return allProductInfos[productKey];
}
export var productInfo = {
    meals: recipeInfo,
    treats: treatInfo,
    probiotics: probioticInfo,
    freeProducts: freeProductInfo,
};
